import { Device, DeviceCategory } from '../../installation/forms'
import { InstallationPath } from '../constants'

const deviceCategoryRoute: Record<DeviceCategory, InstallationPath> = {
  EMC: 'general',
  Storage: 'storage',
  'ModbusTCP Evse': 'charging-stations',
  'EEBus Evse': 'charging-stations',
  Heatpump: 'heatpump',
  Meter: 'meters',
  'HTC320H I/O': 'io-interfaces',
  'Storage I/O': 'io-interfaces',
  'MyPV I/O': 'io-interfaces',
}

export const getDeviceNavigationLink = (device: Device): string => {
  const { deviceCategory, navigationId } = device

  return `${deviceCategoryRoute[deviceCategory]}#${navigationId}`
}
